import { render, staticRenderFns } from "./UnassignedIcon.vue?vue&type=template&id=717c41a0"
import script from "./UnassignedIcon.vue?vue&type=script&lang=js"
export * from "./UnassignedIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports